export default __webpack_public_path__ + "static/InterDisplay-ExtraLightItalic-531633cb6cf6565a1315936e86b47e48.woff2";